import { render } from "./FreerideDialog.vue?vue&type=template&id=b288995c&scoped=true"
import script from "./FreerideDialog.vue?vue&type=script&lang=js"
export * from "./FreerideDialog.vue?vue&type=script&lang=js"

import "./FreerideDialog.vue?vue&type=style&index=0&id=b288995c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b288995c"

export default script